// Generated by home-page/tools/build_theme.py from home-page/assets/js/page.js.
// Noro – početna stranica: tabovi „Video / Pisani utisci“ i red snimaka ulične ankete.
// Custom elementi, pa rade i posle ponovnog iscrtavanja sekcije u editoru Shopify teme
// (connectedCallback se pozove opet). Isti fajl je u temi assets/noro-home.js.
(function () {
  'use strict';

  // Tabovi: klik ili strelice levo/desno biraju tab i prikazuju njegov panel.
  if (!customElements.get('noro-hp-tabs')) {
    customElements.define('noro-hp-tabs', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (e) => {
          const tab = e.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab, false);
        };
        this.onKey = (e) => {
          const tab = e.target.closest('[role="tab"]');
          if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          const tabs = this.tabs();
          const i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
          this.select(tabs[(i + tabs.length) % tabs.length], true);
          e.preventDefault();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
      }

      tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      select(tab, focus) {
        this.tabs().forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }

      // Editor teme: izabran blok (snimak ili pisani utisak) otvara svoj tab.
      showPanelOf(el) {
        const panel = el.closest('[role="tabpanel"]');
        const tab = panel && this.querySelector('[aria-controls="' + panel.id + '"]');
        if (tab) this.select(tab, false);
      }
    });
  }

  // Red snimaka: na telefonu se prevlači prstom, a na računaru i mišem (isto kao na PP stranicama).
  // Kartice su linkovi na Instagram, pa prevlačenje ne sme da se računa kao klik.
  if (!customElements.get('noro-hp-drag')) {
    customElements.define('noro-hp-drag', class extends HTMLElement {
      connectedCallback() {
        let drag = null;
        let suppressClickUntil = 0;
        this.onDown = (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          drag = { x: e.clientX, left: this.scrollLeft, moved: false };
        };
        this.onMove = (e) => {
          if (!drag) return;
          const dx = e.clientX - drag.x;
          if (!drag.moved && Math.abs(dx) > 5) {
            drag.moved = true;
            this.classList.add('is-dragging');
          }
          if (drag.moved) this.scrollLeft = drag.left - dx;
        };
        this.onUp = () => {
          if (!drag) return;
          if (drag.moved) suppressClickUntil = Date.now() + 300;
          drag = null;
          this.classList.remove('is-dragging');
        };
        this.onClick = (e) => {
          if (Date.now() < suppressClickUntil) {
            e.preventDefault();
            e.stopPropagation();
          }
        };
        this.onDragStart = (e) => e.preventDefault();
        this.addEventListener('pointerdown', this.onDown);
        window.addEventListener('pointermove', this.onMove);
        window.addEventListener('pointerup', this.onUp);
        this.addEventListener('click', this.onClick, true);
        this.addEventListener('dragstart', this.onDragStart);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerdown', this.onDown);
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        this.removeEventListener('click', this.onClick, true);
        this.removeEventListener('dragstart', this.onDragStart);
      }
    });
  }

  document.addEventListener('shopify:block:select', (e) => {
    const tabs = e.target.closest && e.target.closest('noro-hp-tabs');
    if (!tabs) return;
    tabs.showPanelOf(e.target);
    if (e.target.matches('.noro-hp-reel')) e.target.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();
